import { MutableRefObject, useRef } from "react";

/**
 * useRef의 lazy initialization 버전.
 * 매 렌더마다 생성자를 실행하는 `useRef(new Foo())` 패턴과 달리,
 * factory는 최초 1회만 호출됩니다.
 */
export function useLazyRef<T>(factory: () => T): MutableRefObject<T> {
  const ref = useRef<T | null>(null);
  if (ref.current === null) {
    ref.current = factory();
  }
  return ref as MutableRefObject<T>;
}
